
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office-design-app",
      function () {
        return require("private-next-pages/office-design-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/office-design-app"])
      });
    }
  